import React from "react";
import { Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CancelledPage() {
  const navigate = useNavigate();

  return (
    <Container sx={{ mt: 10, textAlign: "center" }}>
      <Typography variant="h5" gutterBottom>
        Upgrade Canceled
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        No worries — your upgrade was not completed. You can continue using
        SortlyBooks for free, or try upgrading again when you're ready.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/pricing")}
        sx={{ mr: 2 }}
      >
        Back to Pricing
      </Button>
      <Button variant="text" onClick={() => navigate("/dashboard")}>
        Return to Dashboard
      </Button>
    </Container>
  );
}
